module.exports = __webpack_public_path__ + "static/media/main-video.c3c1e811.jpg";